import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { UserAuthContext } from "./UserAuthContext";

export const useUserAuth = () => {
  const context = useContext(UserAuthContext);

  if (!context) {
    throw new HookOutOfContextError("useUserAuth", "UserAuthContext");
  }

  return context;
};
